import React from "react"
import { Field } from "redux-form/immutable"

import GridToggleSelectField from "app/static/frontend/forms/components/GridToggleSelectField"

// generic component
export const BulkActionsExternalContact = () => (
    <div className="bulk-actions-console-external-contact-form" data-cy="bulk-actions-console-external-contact-form">
        <Field
            allowNull={false}
            choices={DjangIO.app.search.bulkactions.types.ExternalContactType.items().sort(DjangIO.valueSortDescending)}
            className="bulk-actions-form-external-contact"
            component={GridToggleSelectField}
            dropUp={false}
            multi={false}
            name="external_contact"
        />
    </div>
)

export default BulkActionsExternalContact
